// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3qEhs","list":"PatternAutocomplete_list__3M0l1"};